import React, { useState } from 'react';
import ModalContentBase from '../redux/components/modal/modal_content_base';

const SectionIsAgeLimited = ({ circle, event, setEvent, isNew }) => {
  const [showPullDown, setShowPullDown] = useState(
    event.lower_age_limit || event.upper_age_limit ? true : false
  );

  const previewContent = (
    <span>
      <img
        src="/img/question.png"
        className=""
        height="auto"
        style={{ width: '15px' }}
      />
    </span>
  );

  const modalContent = (
    <div>
      <div className="modal-view-header">
        <p style={{ margin: '0 0 6px', padding: '1.5em', textAlign: 'left' }}>
          <strong>
            <p>募集年齢制限とは</p>
          </strong>
        </p>
      </div>
      <div
        className="modal-view-body"
        style={{ padding: '0px 25px 50px', textAlign: 'left' }}
      >
        <p className="pb-3">募集年齢を制限しているイベントです。</p>
        <p className="pb-3">
          設定された年齢の範囲外のユーザーは参加できないよう調整されます。
        </p>
        <p className="pb-3">
          そのため集めたい年齢層のユーザーのみを集められるため安心です。
        </p>
        <p className="pb-3">
          年齢を登録していないユーザーや、タイミングによって条件に合致しないユーザーは参加することができません。
        </p>
        <p className="pb-3">この機能はプレミアムサークルのみが設定可能です。</p>
      </div>
      <div className="modal-view-footer" />
    </div>
  );

  const AgeSelect = (prop) => {
    const options = [];
    options.push(
      <option value="設定なし">
        {prop.name === 'lower_age_limit' ? '下限なし' : '上限なし'}
      </option>
    );
    for (let i = 14; i <= 80; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return (
      <select
        className="custom-select custom-select-sm"
        value={prop.value}
        onChange={(e) => prop.onChange(e.target.value)}
        disabled={!isNew || !circle.is_premium_valid}
      >
        {options}
      </select>
    );
  };

  return (
    <section id="gender_managed">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            募集年齢制限
          </p>
          <div className="ml-1 mt-3-5">
            <ModalContentBase
              previewContent={previewContent}
              modalContent={modalContent}
            />
          </div>
        </div>
        <p className="text-gray text-fz-small mt-0 mb-1">
          ※イベント初回作成時のみ設定できます。あとから変更できません。
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="showPullDown"
              defaultChecked={showPullDown}
              onChange={(e) => {
                setShowPullDown(e.target.checked);
                e.target.checked === false &&
                  setEvent((prev) => ({
                    ...prev,
                    lower_age_limit: null,
                    upper_age_limit: null,
                  }));
              }}
              disabled={!isNew || !circle.is_premium_valid}
            />
            <label className="custom-control-label" htmlFor="showPullDown">
              募集年齢を制限する
            </label>
          </div>
        </div>
        {showPullDown && (
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="d-flex justify-content-between align-items-center">
              <AgeSelect
                name="lower_age_limit"
                value={event.lower_age_limit}
                onChange={(value) => {
                  const age = isNaN(+value) ? null : +value;
                  setEvent((prev) => ({ ...prev, lower_age_limit: age }));
                }}
              />
              <span className="mx-3">〜</span>
              <AgeSelect
                name="upper_age_limit"
                value={event.upper_age_limit}
                onChange={(value) => {
                  const age = isNaN(+value) ? null : +value;
                  setEvent((prev) => ({ ...prev, upper_age_limit: age }));
                }}
              />
              歳
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionIsAgeLimited;
